import script from "./LinkStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkStep.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__